import { useEffect, useRef, useState } from 'react'
import Icon from './Icon'
import { getLocale } from '../lib/i18n'
import { SAVED_EVENT } from '../lib/saved'

/** A small "Saved" note at the bottom of the screen for two seconds after a setting is saved. */
export default function SavedToast() {
  const [shown, setShown] = useState(false)
  const timer = useRef<number | undefined>(undefined)
  useEffect(() => {
    const show = () => { setShown(true); window.clearTimeout(timer.current); timer.current = window.setTimeout(() => setShown(false), 2200) }
    window.addEventListener(SAVED_EVENT, show)
    return () => { window.removeEventListener(SAVED_EVENT, show); window.clearTimeout(timer.current) }
  }, [])
  return <div className="saved-toast" role="status" aria-live="polite" data-shown={shown}>{shown && <><Icon name="check" size={18}/>{getLocale() === 'en' ? 'Saved' : 'Guardado'}</>}</div>
}
